import { render, staticRenderFns } from "./CompareEditions.vue?vue&type=template&id=3192ac6f"
import script from "./CompareEditions.vue?vue&type=script&lang=js"
export * from "./CompareEditions.vue?vue&type=script&lang=js"
import style0 from "./CompareEditions.vue?vue&type=style&index=0&id=3192ac6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports